import { render } from "./NewStudent.vue?vue&type=template&id=f49884a2&scoped=true"
import script from "./NewStudent.vue?vue&type=script&lang=js"
export * from "./NewStudent.vue?vue&type=script&lang=js"

import "./NewStudent.vue?vue&type=style&index=0&id=f49884a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f49884a2"]])

export default __exports__